import { useDocument } from "react-firebase-hooks/firestore";
import React, { useMemo } from "react";
import { Skeleton } from "@mui/material";
import { doc } from "firebase/firestore";
import { db } from "../firebase";

export const WithDoc = ({
  docRef: providedDocRef,
  Component,
  fallbackValue,
  FallbackComponent,
}) => {
  const docRef =
    typeof providedDocRef === "string"
      ? doc(db, providedDocRef)
      : providedDocRef;
  const [document, loading] = useDocument(docRef);
  const data = useMemo(() => {
    if (!document?.exists()) {
      return undefined;
    }
    const data = document.data();
    return {
      id: document.id,
      ...data,
    };
  }, [document]);
  if (loading) {
    return <Skeleton variant="text" sx={{ width: 1, minWidth: 48 }} />;
  }
  if (!data) {
    if (FallbackComponent) {
      return <FallbackComponent />;
    }
    return fallbackValue ?? "Unknown";
  }
  return <Component data={data} />;
};

export const WithDocLoadAware = ({ docRef: providedDocRef, Component }) => {
  const docRef =
    typeof providedDocRef === "string"
      ? doc(db, providedDocRef)
      : providedDocRef;
  const [document, loading, error] = useDocument(docRef);
  const data = useMemo(() => {
    if (!document?.exists()) {
      return undefined;
    }
    const data = document.data();
    return {
      id: document.id,
      ...data,
    };
  }, [document]);
  return <Component data={data} loading={loading} error={error} />;
};
